//* Deals View Toggle Controller
//*
//* Switches the public deals listing between the table view and the
//* card view. Both are server-rendered per month; this controller only
//* swaps which container is visible. The selection is saved to
//* localStorage.
import ApplicationController from "application_controller.js";

const STORAGE_KEY = "deals_view";

export default class extends ApplicationController {
  debug = false;

  static targets = ["table", "cards", "photosButton", "tableButton"];

  connect() {
    if (localStorage.getItem(STORAGE_KEY) === "photos") {
      this.photosView();
    }
  }

  photosView() {
    this.tableTargets.forEach((table) => table.classList.add("d-none"));
    this.cardsTargets.forEach((cards) => cards.classList.remove("d-none"));
    this.photosButtonTarget.classList.add("active");
    this.tableButtonTarget.classList.remove("active");
    localStorage.setItem(STORAGE_KEY, "photos");
  }

  tableView() {
    this.tableTargets.forEach((table) => table.classList.remove("d-none"));
    this.cardsTargets.forEach((cards) => cards.classList.add("d-none"));
    this.tableButtonTarget.classList.add("active");
    this.photosButtonTarget.classList.remove("active");
    localStorage.setItem(STORAGE_KEY, "table");
  }

  //* Lazy-loaded containers connect later and must match the current selection
  tableTargetConnected(table) {
    if (localStorage.getItem(STORAGE_KEY) === "photos") {
      table.classList.add("d-none");
    }
  }

  cardsTargetConnected(cards) {
    if (localStorage.getItem(STORAGE_KEY) === "photos") {
      cards.classList.remove("d-none");
    }
  }
}
